import React from 'react';
import Error from './Error.svg';

const Icon = props => <Error {...props} />;

export default Icon;
